import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade, Navigation, FreeMode, Thumbs, Pagination } from 'swiper';
import { TweenMax } from 'gsap';
import { cx } from '@emotion/css';
import style from '../../index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

SwiperCore.use([EffectFade, Navigation, FreeMode, Thumbs, Pagination]);
const { EFPic } = createEFPic('/media/ces/pc/');

export default function SectionD() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('ces2023');
    const { locale } = useRouter();

    const swiperList = ['03-2', '03-3', '03-4', '03-5', '03-6', '03-7', '03-8', '03-9', '03-10', '03-11', '03-1', '03-12'];
    const subSwiperList = ['03-2', '03-3', '03-4', '03-5', '03-6', '03-7', '03-8', '03-9', '03-10', '03-11', '03-1', '03-12'];

    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [videoModal, setVideoModal] = useState(false);

    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.momentsWrapper',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 1, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '30%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });

        const tweenA1 = TweenMax.fromTo(
            '.momentsWrapper .messageBox',
            0.5,
            {
                opacity: 0,
                ease: 'ease-out',
            },
            {
                opacity: 1,
                ease: 'ease-out',
            },
        );

        sceneA1.setTween(tweenA1);
        controllerCES.addScene(sceneA1);
    }, []);

    return (
        <div className={`${style.momentsWrapper} momentsWrapper`}>
            <div className="staticBox">
                <div className="messageBox">{t('sectionC.title')}</div>
                <div className={cx('imageBox')}>
                    <Swiper
                        thumbs={{ swiper: thumbsSwiper }}
                        className="animL-swiper"
                        loop={true}
                        navigation={true}
                        slidesPerView={'auto'}
                        lazy={true}
                        autoplay={{
                            delay: 4000,
                            disableOnInteraction: false,
                        }}
                        spaceBetween={18}
                        centeredSlides={true}
                        speed={800}
                        modules={[FreeMode, Navigation, Thumbs]}
                    >
                        <SwiperSlide>
                            <div className="video-swiper">
                                <EFPic name={['03-0.webp', '03-0.jpg']} className="img" />
                                <div className="play-btn" onClick={() => setVideoModal(true)}></div>
                            </div>
                        </SwiperSlide>
                        {swiperList.map((item: string, k: number) => (
                            <SwiperSlide key={k}>
                                <EFPic name={[`${item}.webp`, `${item}.jpg`]} className="img" />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                    <Swiper
                        className="sub-animL-swiper"
                        onSwiper={setThumbsSwiper as any}
                        loop={false}
                        spaceBetween={10}
                        modules={[FreeMode, Navigation, Thumbs]}
                        navigation={true}
                        slidesPerView={'auto'}
                        lazy={true}
                        autoplay={false}
                        speed={800}
                    >
                        <SwiperSlide>
                            <div className="sub-swiper__video">
                                <EFPic name={['03-0.webp', '03-0.jpg']} className="img" />
                                <div className="play-btn"></div>
                            </div>
                        </SwiperSlide>
                        {subSwiperList.map((item: string, k: number) => (
                            <SwiperSlide key={k}>
                                <EFPic name={[`${item}.webp`, `${item}.jpg`]} className="img" />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
            <EFVideoModal
                visible={videoModal}
                source={
                    locale === 'cn'
                        ? 'https://player.bilibili.com/player.html?aid=477715453&bvid=BV17K411C7xr&cid=961382248&page=1'
                        : 'https://www.youtube.com/embed/TjoUsnLwVFI'
                }
                onClose={() => setVideoModal(false)}
                playerType={locale === 'cn' ? 'Bilibili' : 'YouTube'}
            />
        </div>
    );
}
